export const userKeys = {
  all: ['users'] as const,
  current: () => [...userKeys.all, 'current'] as const,
  detail: (id: string) => [...userKeys.all, id] as const,
} as const;

export const chartKeys = {
  all: ['charts'] as const,
  lists: () => [...chartKeys.all, 'list'] as const,
  list: (filters: Record<string, unknown>) => [...chartKeys.lists(), filters] as const,
  details: () => [...chartKeys.all, 'detail'] as const,
  detail: (id: string) => [...chartKeys.details(), id] as const,
} as const;

export const profileKeys = {
  all: ['profiles'] as const,
  lists: () => [...profileKeys.all, 'list'] as const,
  list: (userId: string) => [...profileKeys.lists(), userId] as const,
  details: () => [...profileKeys.all, 'detail'] as const,
  detail: (id: string) => [...profileKeys.details(), id] as const,
} as const;

export const templateKeys = {
  all: ['templates'] as const,
  lists: () => [...templateKeys.all, 'list'] as const,
  system: () => [...templateKeys.lists(), 'system'] as const,
  user: (userId: string) => [...templateKeys.lists(), userId] as const,
  details: () => [...templateKeys.all, 'detail'] as const,
  detail: (id: string) => [...templateKeys.details(), id] as const,
} as const;

export const patientKeys = {
  all: ['patients'] as const,
  lists: () => [...patientKeys.all, 'list'] as const,
  list: (officeId: string) => [...patientKeys.lists(), officeId] as const,
  details: () => [...patientKeys.all, 'detail'] as const,
  detail: (id: string) => [...patientKeys.details(), id] as const,
} as const;

export const customTemplateKeys = {
  all: ['customTemplates'] as const,
  lists: () => [...customTemplateKeys.all, 'list'] as const,
  byOrg: (orgId: string) => [...customTemplateKeys.lists(), orgId] as const,
  details: () => [...customTemplateKeys.all, 'detail'] as const,
  detail: (id: string) => [...customTemplateKeys.details(), id] as const,
} as const;

export const headingKeys = {
  all: ['headings'] as const,
  active: () => [...headingKeys.all, 'active'] as const,
} as const;

export const legalKeys = {
  all: ['legal'] as const,
  config: () => [...legalKeys.all, 'config'] as const,
} as const;

export const settingsKeys = {
  all: ['settings'] as const,
  default: () => [...settingsKeys.all, 'default'] as const,
} as const;

export const plansKeys = {
  all: ['plans'] as const,
  stripe: () => [...plansKeys.all, 'stripe'] as const,
} as const;

export const supportKeys = {
  all: ['support'] as const,
  tickets: () => [...supportKeys.all, 'tickets'] as const,
  ticket: (id: string) => [...supportKeys.all, 'ticket', id] as const,
  messages: (ticketId: string) => [...supportKeys.all, 'messages', ticketId] as const,
} as const;

export const referralKeys = {
  all: ['referrals'] as const,
  lists: () => [...referralKeys.all, 'list'] as const,
  list: (userId: string) => [...referralKeys.lists(), userId] as const,
  byChart: (chartId: string) => [...referralKeys.all, 'chart', chartId] as const,
  byPatient: (userId: string, patientId: string) =>
    [...referralKeys.all, 'patient', userId, patientId] as const,
  details: () => [...referralKeys.all, 'detail'] as const,
  detail: (id: string) => [...referralKeys.details(), id] as const,
} as const;

export const specialistKeys = {
  all: ['specialists'] as const,
  lists: () => [...specialistKeys.all, 'list'] as const,
  byOffice: (officeId: string) => [...specialistKeys.lists(), officeId] as const,
} as const;
